export const CandidateInitialValues = {
  name: "",
  email: "",
  jobAssociated: "",
  contactNumber: null,
  totalExperience: null,
  additionalInfo: "",
  examinerList: "",
};
